const isNumber = (value: any) => {
	if (typeof value === 'string' && value.trim().length === 0) {
		return false
	}

	return !isNaN(value)
}

export const numberHelper = {
	isNumber,
}
